import _ from "lodash";
import { defaultFilters, emptyFilters } from "./state";

export const SET_DATA = "SET_DATA";
export const SET_RESOURCES = "SET_RESOURCES";
export const MUTATE_SELECTED_PAGE = "MUTATE_SELECTED_PAGE";
export const MUTATE_LIMIT = "MUTATE_LIMIT";

export const MUTATE_FILTERS = "SET_FILTERS";
export const MUTATE_DEFAULT_FILTERS = "SET_DEFAULT_FILTERS";
export const MUTATE_EMPTY_FILTERS = "SET_EMPTY_FILTERS";

export default {
  [SET_DATA]: (state, data) => {
    state.items = data.data;
    state.count = data.count;
  },
  [SET_RESOURCES]: (state, data) => {
    state.aclResources = data.data;
  },
  [MUTATE_SELECTED_PAGE]: () => {
    // state.pagination.page = page;
  },
  [MUTATE_LIMIT]: (state, limit) => {
    state.limit = limit;
  },
  [MUTATE_FILTERS]: (state, filters) => {
    if (!_.isEqual(_.merge({}, state.filters), filters)) {
      state.filters = filters;
    }
  },
  [MUTATE_DEFAULT_FILTERS]: (state) => {
    state.filters = _.merge({}, defaultFilters);
  },
  [MUTATE_EMPTY_FILTERS]: (state) => {
    state.filters = _.merge({}, emptyFilters);
  },
};
